import { render } from "./UserCourses.vue?vue&type=template&id=76e62159&scoped=true&ts=true"
import script from "./UserCourses.vue?vue&type=script&lang=ts"
export * from "./UserCourses.vue?vue&type=script&lang=ts"

import "./UserCourses.vue?vue&type=style&index=0&id=76e62159&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e62159"]])

export default __exports__